import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Login as LoginComponent } from '@smorder/core';
import { NavigationLink } from '../components';

import config from '../../run-config';

class Login extends Component {
  render() {
    const { classes, ...other } = this.props;

    const content = {
      mail: config.mail,
      telnr: config.telnr,
      copyrightBy: config.copyrightBy,
    };

    const forgotPassword = (
      <NavigationLink to="/forgotPassword">
        <div className={classes.forgotPassword}>Passwort vergessen?</div>
      </NavigationLink>
    );

    const logo = config.loginLogo;

    return (
      <LoginComponent
        {...other}
        {...content}
        logo={logo}
        forgotPassword={forgotPassword}
      />
    );
  }
}

const styles = theme => ({
  forgotPassword: {
    marginTop: 10,
    color: theme.palette.link.main,
    fontWeight: 700,
  },
});

Login.propTypes = {
  login: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
};

Login.defaultProps = {
  isLoading: false,
  errorMessage: null,
};

export default withStyles(styles)(Login);
